module.exports = __webpack_public_path__ + "0.version.14a960a81f2a234f8a5e.worker.js"